/* eslint-disable no-console */
/* eslint-disable no-alert */
import { call, put, select } from 'redux-saga/effects'
import firebase from '../config/firebase'
import AuthActions from '../reducers/authReducer'
import RolePermissionActions from '../reducers/rolePermissionReducer'

export function* updateOnlineStatus({ uid, status }) {
  try {
    const doc = firebase
      .firestore()
      .collection('dashboard_users')
      .doc(uid)

    yield call([doc, doc.update], { online: status === 'Online' })
  } catch (error) {
    console.log(error)
  }
}

export function* handleAuthSuccess({ uid }) {
  const doc = firebase
    .firestore()
    .collection('dashboard_users')
    .doc(uid)
  const snapshot = yield call([doc, doc.get])

  if (snapshot.exists) {
    const user = snapshot.data()

    if (user.role === 'merchant_admin@role') {
      return alert('User does not exist.')
    }

    yield call(updateOnlineStatus, { uid, status: 'Online' })
    yield put(AuthActions.setAuthData(user))
    yield put(AuthActions.setAuthenticated(true))
    yield put(RolePermissionActions.trackUserRole(uid))
    return true
  }

  return alert('User does not exist.')
}

export function* login({ credential }) {
  try {
    const auth = firebase.auth()
    yield call([auth, auth.signInWithEmailAndPassword], credential.email, credential.password)
  } catch (error) {
    yield put(AuthActions.setLoginLoading(false))
    alert(error.message || error)
  }
}

export function* logout() {
  try {
    const auth = yield select(state => state.auth.data)
    const confirmation = window.confirm('Are you sure to log out?')

    if (confirmation) {
      const firebaseAuth = firebase.auth()
      yield call(updateOnlineStatus, { uid: auth.uid, status: 'Offline' })
      yield call([firebaseAuth, firebaseAuth.signOut])
      window.location.reload()
    }
  } catch (error) {
    console.log(error)
  }
}



// WEBPACK FOOTER //
// ./src/sagas/authSaga.js